(function () {
  if (window.AspadzPolicyContentNavLoaded) {
    return;
  }

  window.AspadzPolicyContentNavLoaded = true;

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var instances = [];
  var updateFrame = null;

  function setActive(instance, index) {
    if (!instance.items[index]) {
      return;
    }

    if (instance.activeIndex !== index) {
      instance.items.forEach(function (item, itemIndex) {
        if (itemIndex === index) {
          item.link.setAttribute('aria-current', 'location');
        } else {
          item.link.removeAttribute('aria-current');
        }
      });

      instance.activeIndex = index;
    }

    var activeItem = instance.items[index].item;

    instance.nav.style.setProperty('--aspadz-policy-active-top', activeItem.offsetTop + 'px');
    instance.nav.style.setProperty('--aspadz-policy-active-height', activeItem.offsetHeight + 'px');
  }

  function getReadingIndex(instance) {
    var readingLine = getStickyTop(instance) + 1;
    var activeIndex = 0;

    instance.items.forEach(function (item, index) {
      if (item.heading.getBoundingClientRect().top <= readingLine) {
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function getStickyTop(instance) {
    var stickyTop = parseFloat(window.getComputedStyle(instance.nav).top);

    if (Number.isNaN(stickyTop)) {
      return instance.nav.getBoundingClientRect().top;
    }

    return stickyTop;
  }

  function alignHeadingToNav(instance, index) {
    var target = instance.items[index];

    if (!target) {
      return;
    }

    function align() {
      var delta = target.heading.getBoundingClientRect().top - getStickyTop(instance);

      if (Math.abs(delta) > 0.5) {
        window.scrollBy(0, delta);
      }
    }

    align();

    window.requestAnimationFrame(function () {
      align();
      requestUpdate();
    });
  }

  function updateFragment(heading) {
    var fragment = '#' + encodeURIComponent(heading.id);

    if (window.location.hash === fragment) {
      return;
    }

    if (window.history && typeof window.history.pushState === 'function') {
      window.history.pushState(null, '', fragment);
      return;
    }

    window.location.hash = heading.id;
  }

  function updateInstance(instance) {
    if (!instance.root.isConnected || !desktopQuery.matches) {
      return instance.root.isConnected;
    }

    setActive(instance, getReadingIndex(instance));
    return true;
  }

  function updateInstances() {
    updateFrame = null;
    instances = instances.filter(updateInstance);
  }

  function requestUpdate() {
    if (updateFrame !== null) {
      return;
    }

    updateFrame = window.requestAnimationFrame(updateInstances);
  }

  function initPolicyContent(root) {
    if (!root || root.dataset.aspadzPolicyNavInitialized === 'true') {
      return;
    }

    var nav = root.querySelector('[data-aspadz-policy-toc]');
    var mobileDisclosure = root.querySelector('[data-aspadz-policy-mobile-toc]');

    if (!nav) {
      return;
    }

    var items = [];

    nav.querySelectorAll('[data-aspadz-policy-target]').forEach(function (link) {
      var heading = document.getElementById(link.dataset.aspadzPolicyTarget);
      var item = link.closest('.aspadz-policy-content__toc-item');

      if (!heading || !root.contains(heading) || !item) {
        return;
      }

      items.push({
        heading: heading,
        item: item,
        link: link,
      });
    });

    if (!items.length) {
      return;
    }

    var instance = {
      activeIndex: -1,
      items: items,
      nav: nav,
      root: root,
    };

    root.dataset.aspadzPolicyNavInitialized = 'true';
    instances.push(instance);

    items.forEach(function (item, index) {
      item.link.addEventListener('click', function (event) {
        if (
          !desktopQuery.matches ||
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        setActive(instance, index);
        updateFragment(item.heading);
        alignHeadingToNav(instance, index);
      });
    });

    if (mobileDisclosure) {
      mobileDisclosure.querySelectorAll('[data-aspadz-policy-target]').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileDisclosure.removeAttribute('open');
        });
      });
    }

    var hashTarget = window.location.hash.slice(1);

    try {
      hashTarget = decodeURIComponent(hashTarget);
    } catch (error) {
      // Keep the raw fragment when a malformed escape sequence is present.
    }

    var hashIndex = items.findIndex(function (item) {
      return item.heading.id === hashTarget;
    });

    setActive(instance, hashIndex >= 0 ? hashIndex : getReadingIndex(instance));
  }

  function initAllPolicyContent(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-aspadz-policy-content]')) {
      initPolicyContent(scope);
    }

    scope.querySelectorAll('[data-aspadz-policy-content]').forEach(initPolicyContent);
    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllPolicyContent(document);
    });
  } else {
    initAllPolicyContent(document);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('hashchange', requestUpdate);

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', requestUpdate);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(requestUpdate);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllPolicyContent(event.target);
  });

  document.addEventListener('shopify:section:unload', requestUpdate);

  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target.matches('[data-aspadz-policy-title]')) {
      return;
    }

    instances.forEach(function (instance) {
      var selectedIndex = instance.items.findIndex(function (item) {
        return item.heading === event.target;
      });

      if (selectedIndex >= 0) {
        setActive(instance, selectedIndex);
      }
    });
  });
})();
